import styled from 'styled-components'

import {
  THEME,
  CSS_ELEMENTS_RESETS,
  typeScale,
  getColorLayers,
  COLORS,
} from '../../styles'
import LikeOrDislikeInput from '../LikeOrDislikeInput'
import MarkdownText from '../MarkdownText'
import RatingStarsInput from '../RatingStarsInput'
import RecipeAuthorBadge from '../RecipeAuthorBadge'

const Styled = styled.div`
  position: relative;
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
`
Styled.title = styled.div`
  ${typeScale('headline2')};
  text-align: center;
  padding-bottom: 1.6rem;
  width: 100%;
`
Styled.author = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  padding-bottom: 0.8rem;
`
Styled.authorLabel = styled.p`
  ${typeScale('caption')};
  padding-right: 0.8rem;
`
Styled.authorAvatar = styled(RecipeAuthorBadge)``
Styled.thumbnail = styled.div`
  width: 9.2rem;
  height: 9.2rem;
  display: block;
  margin: 0 auto 1.6rem;
  border: ${({ isUserGenerated }) =>
    isUserGenerated ? `0.4rem solid ${COLORS.yolk}` : '0'};
  border-radius: ${({ isUserGenerated }) => (isUserGenerated ? '9999px' : '0')};
  overflow: ${({ isUserGenerated }) => (isUserGenerated ? 'hidden' : 'unset')};
`
Styled.subtitle = styled(MarkdownText)`
  ${typeScale('body')};
  color: ${THEME.COLORS.foreground.primary};
  padding-bottom: 1.6rem;
  text-align: center;

  em {
    color: ${THEME.COLORS.foreground.secondary};
  }

  strong {
    ${typeScale('body', { fontWeight: 'bold' })};
  }
`
Styled.stars = styled(RatingStarsInput)`
  display: flex;
  align-items: center;
  justify-content: center;
`
Styled.separator = styled.hr`
  height: 0.1rem;
  width: 100%;
  border: 0;
  border-bottom: 0.1rem dashed ${THEME.COLORS.foreground.tertiary};
  margin: 2.4rem 0;
`
Styled.options = styled.div``
Styled.option = styled(LikeOrDislikeInput)`
  margin-bottom: 3.2rem;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -1.6rem;
    left: 0;
    height: 0.1rem;
    width: 100%;
    border: 0;
    border-bottom: 0.1rem dashed ${THEME.COLORS.foreground.tertiary};
  }

  &:last-child {
    margin-bottom: 0;

    &:after {
      display: none;
    }
  }
`
Styled.textArea = styled.textarea`
  ${CSS_ELEMENTS_RESETS.inputText};
  background-color: ${THEME.COLORS.background.primary};
  padding: 1.2rem 1.6rem;
  text-align: left;
  display: block;
  width: 100%;
  border-radius: 1.6rem;
  resize: vertical;

  &::placeholder {
    ${typeScale('caption')};
    color: ${THEME.COLORS.foreground.secondary};
  }
`
Styled.footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-flow: column nowrap;
  padding: 2.4rem 0 0;
  position: sticky;
  bottom: 0;
  left: 0;
  flex: 1;
`
Styled.submit = styled.button`
  ${CSS_ELEMENTS_RESETS.button};
  ${typeScale('button')};
  color: ${COLORS.white};
  background-color: ${COLORS.primary};
  padding: 1.2rem 1.6rem;
  text-align: center;
  border-radius: 9999px;
  transition:
    background 0.2s ease-in-out,
    color 0.2s ease-in-out;

  &:disabled {
    background: ${getColorLayers([
      THEME.COLORS.foreground.tertiary,
      THEME.COLORS.background.secondary,
    ])};
    color: ${THEME.COLORS.foreground.secondary};
  }
`

export default Styled
